"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { randomString } from "../utils";
var clickHandlers = /* @__PURE__ */new Map();
if (typeof document !== "undefined") {
  document.addEventListener("click", function (event) {
    clickHandlers.forEach(function (handler) {
      handler(event);
    });
  });
}
var OnClickOutside = /*#__PURE__*/function () {
  function OnClickOutside(ignoreElems, onClickOutside) {
    _classCallCheck(this, OnClickOutside);
    this.onClickOutside = onClickOutside;
    this.handlerId = randomString();
    this.ignoreElemsSelector = ignoreElems.join(",");
  }
  _createClass(OnClickOutside, [{
    key: "startListening",
    value: function startListening() {
      var _this = this;
      clickHandlers.set(this.handlerId, function (event) {
        if (_this.outsideIgnorableElems(event.target)) {
          _this.stopListening();
          return _this.onClickOutside();
        }
      });
    }
  }, {
    key: "stopListening",
    value: function stopListening() {
      clickHandlers.delete(this.handlerId);
    }
  }, {
    key: "outsideIgnorableElems",
    value: function outsideIgnorableElems(target) {
      return !target.matches(this.ignoreElemsSelector) && this.parents(target, this.ignoreElemsSelector).length === 0;
    }
  }, {
    key: "parents",
    value: function parents(element, selector) {
      var parents = [];
      var node = element;
      do {
        node = node.parentNode;
        if (node instanceof Element && selector && node.matches(selector)) {
          parents.push(node);
        }
      } while (node && node !== document);
      return parents;
    }
  }]);
  return OnClickOutside;
}();
export { OnClickOutside as default };